<template>
    <div>
        <b-jumbotron>
            <h1>Apps</h1>
            <hr />
            <p>
                Download the WireGuard App for your device.
            </p>
            <AppList />
        </b-jumbotron>
    </div>
</template>

<script>
    import AppList from '@/components/user/apps/list'

    export default {
        components: {
            AppList
        }
    }
</script>